/* ============================================================================
   collection.js — Filtern, Sortieren, Nachladen (<nko-collection>)
   ----------------------------------------------------------------------------
   Ersetzt `theme.collectionTemplate` aus assets/app.js:430-663 (234 Zeilen
   jQuery), den Sortier-Handler ausserhalb des Moduls (app.js:963-997) und den
   Ladeschleier (app.js:10-13, 121-132).

   Vertrag: docs/collection-contract.md · Ledger: docs/collection-bug-ledger.md

   GELADEN von den Sections, die <nko-collection> rendern (R5, seit M5; bis
   dahin als nko-collection.js ueber ein Gate im <head>):
     sections/main-collection.liquid  Kollektion (Normalzweig)
     sections/main-blog.liquid        Blog, nur der Nachlade-Zweig

   DREI AUSLOESER, EIN WEG
   ---------------------------------------------------------------------------
   Tag-Klick, Sortieren und Nachladen (dazu die Zurueck-Taste) muenden alle
   in `hole(url, art)`. Aus der Antwort werden uebernommen: das Raster, der
   Zaehler, die Paginierung und — ausser beim Nachladen — der Filterinhalt,
   Beschriftung und Optionen der Sortierung und die Unterkategorie-Chips.
   Alles, was von der Adresse abhaengt, kommt so aus dem Server und kann
   nicht mehr gegen sie laufen (Sortierbeschriftung nach Zurueck, Tag-Links
   ohne das aktive sort_by, Sortier-Links ohne den aktiven Tag).

   Unterkategorie-Chips sind seit D-CHIPS (b) echte Links und navigieren
   selbst; der AJAX-Zweig dafuer ist weg.

   E3 — SECTION RENDERING API STATT GANZER SEITE
   ---------------------------------------------------------------------------
   Der Altbestand lud per `$.load()` die KOMPLETTE Zielseite und schnitt vier
   Stuecke heraus. Nachgemessen: 578-600 KB je Interaktion, davon allein 193 KB
   Megamenue, das niemand braucht.

   Jetzt `?section_id=…`. Nachgemessen an /collections/brillen: 98 KB statt
   600 KB, alle vier Fragmente enthalten, Megamenue null.

   WAS DIE BAUWEISE VON SELBST BESEITIGT
   ---------------------------------------------------------------------------
   KOL-05 (freigegeben) — der Altbestand haengte seine Handler nach JEDEM
   Austausch neu an (`reinit()`), ohne die alten zu loesen. Nach drei Filtern
   feuerte ein Klick viermal. Hier haengt genau EIN Handler am Element und
   arbeitet mit Ereignisdelegation; ausgetauschter Inhalt ist ihm gleich.

   KOL-17 (NICHT freigegeben, faellt aber durch die Bauweise weg) — der
   Ladeschleier hatte weder Timeout noch Fehlerpfad: blieb die Antwort aus,
   drehte er sich fuer immer. `try/finally` ist die natuerliche Form in
   async-Code; ihn hier absichtlich hangen zu lassen waere aktiv schaedlich.
   Bitte nachtraeglich quittieren.

   WAS AUSDRUECKLICH REPARIERT IST (E4, einzeln freigegeben)
   ---------------------------------------------------------------------------
   KOL-01  Der Filter war unter 991px komplett tot: `updateScroll(true)` lief
           VOR dem Request und griff auf `$('[data-scroll-to]').offset()` zu —
           ein Element, das es im gerenderten Markup nicht gibt. Der TypeError
           brach ab, bevor irgendetwas geladen wurde; die Checkbox wurde
           trotzdem optisch aktiv. Nach E2 wird auf Mobil jetzt gefiltert, aber
           NICHT gescrollt.
   KOL-02  Die Paginierung blieb stehen, wenn die Antwort keine enthielt:
           `$.html(undefined)` ist ein GETTER, kein Setzer. Nach einem Filter
           auf wenige Treffer hing dort weiter "9 von 27" mit ?page=2 — ein
           Klick haengte fremde Produkte an. Hier wird immer gesetzt, notfalls
           auf leer.
   KOL-03  Sortieren verwarf einen aktiven Tag-Filter, weil die Sortier-URL aus
           `data-url` kam und das die Kollektions-URL OHNE Tags ist. Der
           erste Fix fuehrte `data-url` nur bei Klicks nach — beim Direktaufruf
           von /collections/brillen/s und nach Zurueck griff er nicht. Jetzt
           gibt es kein `data-url` mehr: `sortiere()` nimmt die aktuelle
           Adresse und ersetzt nur `sort_by`.
   KOL-04  Bei null Treffern blieb die alte Liste stehen. Das Raster wird jetzt
           immer gesetzt; die Leermeldung kommt aus dem Markup.

   Ebenfalls behoben (Ledger, alle freigegeben): KOL-10 Zurueck-Taste,
   KOL-11 ?page=2 in der Adresse, KOL-12 Anfrage-Reihenfolge, KOL-13 toter
   optimistischer Chip — jeweils an der Stelle im Code begruendet. KOL-14/15
   (Chip-Leiste und Markierung) loest der Server in main-collection.liquid.
   ========================================================================== */

const MOBIL = 991;

/* Der Ladeschleier hing im Altbestand als festes Element am <body>
   (app.js:11). Ohne app.js gibt es ihn nicht — der Kranz steht in base.css,
   der Schalter `.js-loader-show` in section-main-collection.css. Deshalb
   einmal nachziehen, wenn er fehlt. */
function schleier() {
  let el = document.querySelector(".loader");
  if (!el) {
    el = document.createElement("div");
    el.className = "loader";
    el.innerHTML = "<i></i>".repeat(12);
    document.body.appendChild(el);
  }
  return el;
}

/* Nur der Kranz, kein Dimmen. Hier stand zusaetzlich `opacity: 0.6` auf
   .js-collection-data-content — darin sitzt aber die fixe Filter-Schublade.
   Deckkraft unter 1 macht daraus einen eigenen Stapelkontext: waehrend jeder
   Anfrage lag der Sticky-Header UEBER der Schublade, und sie war
   halbtransparent. LIVE dimmt nicht (app.js fadete `.js-update`, das es auf
   der Kollektion nicht gibt). Der Container der Schublade darf weder
   opacity noch transform noch filter bekommen. */
function zeigeSchleier(an) {
  schleier();
  document.body.classList.toggle("js-loader-show", an);
}

class NkoCollection extends HTMLElement {
  connectedCallback() {
    this.sektion = this.getAttribute("data-section") || "";
    this.laeuft = false;
    /* KOL-12 — jede Anfrage bekommt eine Nummer. Trifft eine Antwort ein,
       deren Nummer nicht mehr die neueste ist, wird sie verworfen. Vorher
       gewann die zuletzt EINTREFFENDE Antwort, nicht der zuletzt geklickte
       Filter: wer schnell zwei Tags anklickte, sah je nach Laufzeit den
       ersten. */
    this.marke = 0;

    /* EIN AbortController fuer alle Hoerer, auch die an `document` und
       `window` (architektur §5.1). disconnectedCallback loest sie in einem
       Zug; wird das Element wieder eingehaengt (Theme-Editor), haengen sie
       nicht doppelt. */
    this.hoerer = new AbortController();
    const { signal } = this.hoerer;

    this.addEventListener("click", (e) => this.klick(e), { signal });

    /* Klapplisten schliessen, wenn daneben geklickt wird. Am Dokument, weil
       der Klick ausserhalb dieses Elements liegen kann. */
    document.addEventListener(
      "click",
      (e) => {
        if (!e.target.closest?.(".selectBox")) {
          for (const s of this.querySelectorAll(".selectBox.is-open")) {
            this.klappe(s, false);
          }
        }
      },
      { signal }
    );

    /* Tastatur: Escape schliesst die Sortierliste und gibt den Fokus an den
       Knopf zurueck; verlaesst der Fokus die Liste per Tab, geht sie zu. */
    this.addEventListener(
      "keydown",
      (e) => {
        if (e.key !== "Escape") return;
        const box = e.target.closest?.(".selectBox.is-open");
        if (!box) return;
        e.preventDefault();
        this.klappe(box, false);
        box.querySelector(".selectBox__name")?.focus();
      },
      { signal }
    );
    this.addEventListener(
      "focusout",
      (e) => {
        const box = e.target.closest?.(".selectBox.is-open");
        if (box && !box.contains(e.relatedTarget)) this.klappe(box, false);
      },
      { signal }
    );

    /* KOL-10 — behoben. Filtern und Sortieren schreiben per `pushState` in den
       Verlauf, aber niemand hoerte auf `popstate`: die Zurueck-Taste aenderte
       die Adresse und liess den Inhalt stehen. Jetzt wird der Inhalt zur
       neuen Adresse nachgeladen — ohne selbst wieder in den Verlauf zu
       schreiben, sonst kaeme man nie heraus.

       NUR BEI GEAENDERTEM PFAD ODER QUERY. `popstate` feuert auch bei reiner
       Fragment-Navigation: Skip-Link (#MainContent), "» Mehr erfahren"
       (#mehr) und Zurueck ueber einen solchen Eintrag. Jedes Mal wurde die
       Section neu geholt, Schleier und Scroll liefen, und alle per "Mehr
       laden" angehaengten Produkte waren weg (18 → 9 Kacheln). `stand` ist
       die Adresse, zu der das Raster gerade passt. */
    this.stand = location.pathname + location.search;
    window.addEventListener(
      "popstate",
      () => {
        const jetzt = location.pathname + location.search;
        if (jetzt === this.stand) return;
        this.hole(jetzt, "filter");
      },
      { signal }
    );
  }

  /* Hoerer loesen und eine laufende Anfrage abbrechen — ihre Antwort haette
     kein Element mehr, in das sie gehoert. */
  disconnectedCallback() {
    this.hoerer?.abort();
    this.laufendeAnfrage?.abort();
  }

  klick(e) {
    const ziel = e.target;

    /* Sortier-Klappliste auf/zu — der Knopf ist ein <button>, Enter und
       Leertaste kommen also als Klick an. */
    const name = ziel.closest?.(".selectBox .selectBox__name");
    if (name) {
      e.preventDefault();
      const box = name.closest(".selectBox");
      this.klappe(box, !box.classList.contains("is-open"));
      return;
    }

    /* Sortieroption gewaehlt. Die Option ist ein Link und sortiert ohne JS
       selbst; hier wird sie abgefangen und per AJAX geladen. */
    const option = ziel.closest?.(".selectBox .selectBox__option");
    if (option) {
      e.preventDefault();
      const box = option.closest(".selectBox");
      for (const s of this.querySelectorAll(".selectBox__option.is-selected")) {
        s.classList.remove("is-selected");
        s.removeAttribute("aria-current");
      }
      option.classList.add("is-selected");
      option.setAttribute("aria-current", "true");
      this.klappe(box, false);
      /* Der Fokus stuende sonst auf einem gerade verborgenen Link. */
      box.querySelector(".selectBox__name")?.focus();
      if (box.classList.contains("js-sort-selectbox")) {
        /* Sofort beschriften (E6: die tatsaechliche Sortierung zeigen);
           hole() setzt danach den Text aus der Antwort. */
        const wert = box.querySelector(".selectBox__value");
        if (wert) wert.textContent = option.textContent.trim();
        this.sortiere(option.getAttribute("data-value"));
      }
      return;
    }

    /* Nachladen */
    const mehr = ziel.closest?.(".js-pagination .btn");
    if (mehr) {
      e.preventDefault();
      const url = mehr.getAttribute("href");
      if (url) this.hole(url, "pagination");
      return;
    }

    /* Tag-Filter */
    const tag = ziel.closest?.(".tag__list a");
    if (tag && !tag.classList.contains("no-ajax")) {
      e.preventDefault();
      this.tagKlick(tag);
    }
  }

  klappe(box, auf) {
    box.classList.toggle("is-open", auf);
    box.querySelector(".selectBox__name")?.setAttribute("aria-expanded", String(auf));
  }

  get kombiniert() {
    const sb = this.querySelector("#CollectionSidebar");
    return sb ? sb.getAttribute("data-combine-tags") === "true" : false;
  }

  tagKlick(a) {
    const url = a.getAttribute("href");
    const li = a.parentElement;

    /* Der geklickte Link verschwindet gleich mit dem Tausch des
       Filterinhalts, der Fokus fiele auf <body> und Tab verliesse die
       Schublade. Gemerkt wird, wohin er danach gehoert: zum gleichnamigen
       Link in derselben Liste (Chip oder Checkbox). */
    this.fokusZiel = {
      text: a.textContent.trim(),
      chip: !!a.closest(".tag__list--selected"),
    };

    if (this.kombiniert) {
      if (li.classList.contains("tag__item--active")) {
        li.classList.remove("tag__item--active");
        a.removeAttribute("aria-current");
      } else {
        li.classList.add("tag__item--active");
        a.setAttribute("aria-current", "true");
        if (li.classList.contains("tag__item--remove")) {
          li.remove();
        } else {
          const liste = this.querySelector(".tag__list--selected");
          if (liste) {
            const chip = document.createElement("div");
            chip.className = "tag__item tag__item--remove";
            const link = document.createElement("a");
            link.className = "tag__link js-no-transition";
            link.textContent = a.textContent;
            /* KOL-13 — behoben. Der Chip hatte bis zur Antwort weder href noch
               Handler: wer ihn sofort wieder wegklicken wollte, klickte ins
               Leere. Die Adresse, die den Tag wieder entfernt, ist genau die
               AKTUELLE — also die vor dem gleich folgenden pushState. Deshalb
               wird sie hier gemerkt und gesetzt; der Delegat auf
               `.tag__list a` greift damit sofort. */
            link.setAttribute("href", location.pathname + location.search);
            chip.appendChild(link);
            liste.appendChild(chip);
          }
        }
      }
    } else {
      for (const el of this.querySelectorAll(".tag__list a")) {
        el.parentElement?.classList.remove("tag__item--active");
        el.removeAttribute("aria-current");
      }
      li.classList.add("tag__item--active");
      a.setAttribute("aria-current", "true");
    }

    if (!url) return;
    history.pushState({}, "", url);
    this.hole(url, "filter");
  }

  /* KOL-03 — die Sortier-URL ist die AKTUELLE Adresse mit ersetztem sort_by.
     Ein aktiver Tag steckt im Pfad und bleibt so erhalten, gleich ob er per
     Klick, per Direktaufruf oder per Zurueck dorthin kam. `page` faellt weg:
     sortiert wird ab Seite 1. */
  sortiere(wert) {
    const u = new URL(location.href);
    u.searchParams.set("sort_by", wert);
    u.searchParams.delete("page");
    const ziel = u.pathname + u.search;
    history.pushState({}, "", ziel);
    this.hole(ziel, "sort");
  }

  scrolleZumRaster() {
    /* E2 — auf Mobil wird gefiltert, aber NICHT gescrollt. Der Altbestand
       versuchte es und stuerzte dabei ab (KOL-01). */
    if (window.matchMedia(`(max-width: ${MOBIL}px)`).matches) return;

    const ziel = this.querySelector("#CollectionAjaxResult");
    if (!ziel) return;
    const kopf = document.querySelector(".header");
    const abstand = (kopf ? kopf.getBoundingClientRect().height : 0) + 20;
    const y = ziel.getBoundingClientRect().top + window.scrollY - abstand;
    window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
  }

  async hole(url, art) {
    if (art === "filter") this.scrolleZumRaster();

    const meine = ++this.marke;

    /* ABBRUCH STATT NUR VERWERFEN.

       `this.marke` sorgt schon dafuer, dass eine ueberholte Antwort nicht
       eingebaut wird — sie wurde aber trotzdem vollstaendig geladen. Wer
       schnell drei Filter anklickt, zog drei komplette Section-Antworten
       ueber die Leitung und benutzte eine davon. Auf dem Telefon ist das
       Bandbreite, die dem sichtbaren Ergebnis fehlt.

       `AbortController` bricht die vorige Anfrage wirklich ab. Die Marke
       bleibt trotzdem: `abort()` wirkt nicht rueckwirkend auf eine Antwort,
       die schon im Zulauf ist. */
    this.laufendeAnfrage?.abort();
    const abbruch = new AbortController();
    this.laufendeAnfrage = abbruch;

    /* Filtern, Sortieren und Zurueck haben die Adresse schon gesetzt; zu ihr
       passt das Raster nach dieser Antwort. Nachladen aendert sie nicht. */
    if (art !== "pagination") this.stand = location.pathname + location.search;

    this.setAttribute("aria-busy", "true");
    zeigeSchleier(true);
    try {
      const u = new URL(url, location.origin);
      if (this.sektion) u.searchParams.set("section_id", this.sektion);

      const antwort = await fetch(u.pathname + u.search, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
        signal: abbruch.signal,
      });
      if (!antwort.ok) throw new Error(`section_id antwortete ${antwort.status}`);

      const text = await antwort.text();
      if (meine !== this.marke) return; /* KOL-12: ueberholte Antwort */
      const doc = new DOMParser().parseFromString(text, "text/html");

      /* KOL-11 — behoben. Hier stand ein `replaceState`, das nach JEDEM Laden
         die geladene URL in die Adresszeile schrieb. Beim Filtern und Sortieren
         war das folgenlos, weil `pushState` sie schon gesetzt hat. Beim
         NACHLADEN stand danach `?page=2` in der Adresse: wer neu lud, bekam
         Seite 2 ohne Seite 1. Die Zeile ist ersatzlos weg — beim Nachladen
         soll die Adresse gar nicht wandern. */

      const raster = this.querySelector(".js-products-row");
      const neuesRaster = doc.querySelector(".js-products-row");
      if (raster) {
        if (art === "pagination" && neuesRaster) {
          raster.append(...neuesRaster.childNodes);
        } else {
          /* KOL-04 — immer setzen, notfalls auf leer. Der Altbestand liess bei
             null Treffern die alte Liste stehen. */
          raster.innerHTML = neuesRaster ? neuesRaster.innerHTML : "";
        }
      }

      if (art !== "pagination") {
        /* Auch beim Sortieren: die Tag-Links tragen das aktive sort_by (so
           rendert Shopify link_to_add_tag), ohne Tausch verloren sie es. */
        this.ersetze(".js-filter-content", doc);
        if (doc.querySelector(".js-sort-selectbox")) {
          this.ersetze(".js-sort-selectbox .selectBox__value", doc);
          this.ersetze(".js-sort-selectbox .selectBox__dd", doc);
        }
        this.ersetze(".subcollection__container", doc);
        if (art === "filter") this.fokusZurueck();
      }
      this.ersetze(".js-products-counter", doc);
      /* KOL-02 — auch dann setzen, wenn die Antwort keine Paginierung
         enthaelt. jQuerys .html(undefined) war ein Getter und liess den alten
         Stand stehen; ein Klick hing danach fremde Produkte an. */
      this.ersetze(".js-pagination", doc);

      /* D-REVIEWS — Sterne fuer die neuen Kacheln. Das reviews.io-Snippet
         (sections/scripts-group.json) laeuft genau einmal ueber die Seite;
         nachgeladene oder gefilterte Kacheln blieben ohne Sterne (21 Kacheln,
         9 mit Sternen). `reinitialiseRatingSnippet` ist die eigene
         Neu-Init der Bibliothek mit den Optionen des ersten Aufrufs — die
         Konfiguration bleibt so an einer Stelle. Fehlt das Skript (noch
         nicht geladen oder entfernt), passiert nichts. */
      if (typeof window.reinitialiseRatingSnippet === "function") {
        window.reinitialiseRatingSnippet();
      }
    } catch (fehler) {
      /* Ein Abbruch ist kein Fehler — er ist der Normalfall, wenn jemand
         schnell weiterklickt. */
      if (fehler.name === "AbortError") return;
      /* Kein console.* (architektur §5.1, frueher entfernte es der Bau);
         der Fehler wird sichtbar und hoerbar in der Zaehlanzeige gemeldet. */
      this.melde();
    } finally {
      if (meine === this.marke) {
        zeigeSchleier(false);
        this.setAttribute("aria-busy", "false");
      }
    }
  }

  /* Ein gescheiterter Filter war fuer den Kunden nicht von "keine Treffer" zu
     unterscheiden: die Liste wurde auf leer gesetzt, der Schleier ging aus,
     und in der Konsole stand etwas, das der fruehere Bau (`drop: ["console"]`)
     entfernte. Jetzt steht es in der Zaehlanzeige, die schon eine Live-Region
     ist — also ohne zusaetzliches Markup und mit Ansage. */
  melde() {
    const ziel = this.querySelector(".js-products-counter");
    if (ziel) ziel.textContent = "?";
  }

  /* Fokus nach dem Tausch des Filterinhalts zurueck in die Schublade — aber
     nur, wenn er dabei verloren ging (auf <body>) und die Schublade noch
     offen ist. Wer inzwischen woanders steht, wird nicht zurueckgerissen. */
  fokusZurueck() {
    const merk = this.fokusZiel;
    this.fokusZiel = null;
    const schublade = this.querySelector(".popup--filter.is-shown");
    if (!merk || !schublade) return;
    const jetzt = document.activeElement;
    if (jetzt && jetzt !== document.body) return;

    const gleich = [...schublade.querySelectorAll(".js-filter-content .tag__link")].filter(
      (l) => l.textContent.trim() === merk.text
    );
    const ziel =
      gleich.find((l) => !!l.closest(".tag__list--selected") === merk.chip) ||
      gleich[0] ||
      schublade.querySelector(".popup__inner");
    ziel?.focus();
  }

  ersetze(wahl, doc) {
    const alt = this.querySelector(wahl);
    if (!alt) return;
    const neu = doc.querySelector(wahl);
    alt.innerHTML = neu ? neu.innerHTML : "";
  }
}

if (!customElements.get("nko-collection")) {
  customElements.define("nko-collection", NkoCollection);
}

/* ----------------------------------------------------------------------------
   NUR ALS MODUL LADEN: <script src="…" type="module">, nie mit `defer`.

   Diese Datei wird ungebaut ausgeliefert. Frueher packte esbuild sie in eine
   IIFE; diesen eigenen Gueltigkeitsbereich gibt ihr jetzt der Modulbereich.
   Als klassisches Skript laegen alle Namen oben global und stiessen sich an
   denen der anderen Theme-Dateien (`FOKUSSIERBAR` steht in zwei, `starte` in
   mehreren), und `open` aus popup.js ueberschriebe `window.open`. Module
   laufen wie `defer` nach dem Parsen in Dokumentreihenfolge, aber nur einmal
   je URL und immer im strict mode.
   ---------------------------------------------------------------------------- */
